
const horariofechamentoGridConfig = {
  idField: "idHorario",
  columns: [
    { header: "Tipo", 
      field: "TIPO",
      formatter: (value) => {
        switch (value) {
          case "F": return "Folga";
          case "D": return "Dia";
          case "H": return "Hora";
          default: return "-";
        }
      }
    },
    { header: "Dia da Semana", 
      field: "DIA_SEMANA",
      formatter: (value) => {
        switch (value) {
          case 7: return "Domingo";
          case 1: return "Segunda-Feira";
          case 2: return "Terça-Feira";
          case 3: return "Quarta-Feira";
          case 4: return "Quinta-Feira";
          case 5: return "Sexta-Feira";
          case 6: return "Sábado";
          default: return "-";
        }
      }
    },
    { header: "Data", field: "DATA" },
    { header: "Horário", field: "HORARIO", 
      formatter: (value) => value !== null && value !== undefined
      ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Ativo", field: "ATIVO", 
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};
export default horariofechamentoGridConfig;